import React from 'react';
import { Alert, Box, Typography, Link } from '@mui/material';
import { API_BASE_URL } from '../../utils/api';

const PING_URL = API_BASE_URL.replace(/\/api\/?$/, '') + '/api/settings/ping';

/**
 * Shows a consistent error for Settings pages and hints for fixing "endpoint not found" / "failed to load".
 */
const SettingsErrorAlert = ({ message, path, status }) => {
  const detail = [path, status ? `HTTP ${status}` : null].filter(Boolean).join(' · ');
  return (
    <Box sx={{ mb: 2 }}>
      <Alert severity="error" sx={{ mb: 1 }}>
        {message}
        {detail && (
          <Typography component="span" display="block" variant="body2" sx={{ mt: 0.5, opacity: 0.9 }}>
            {detail}
          </Typography>
        )}
      </Alert>
      <Alert severity="info">
        <Typography variant="body2" component="span">
          <strong>API base:</strong> {API_BASE_URL}
          <br />
          If you see &quot;Endpoint not found&quot; or &quot;Failed to load&quot;:
          <br />
          1. <strong>Redeploy:</strong> Run <code>./deployments/kubernetes/deploy-superadmin.sh</code> from the repo root, then restart port-forward.
          <br />
          2. <strong>Use port-forward:</strong> Run <code>./deployments/kubernetes/port-forward-superadmin.sh</code> and open <strong>http://localhost:8000</strong> (not NodePort 30800).
          <br />
          3. <strong>Check backend:</strong> Open <Link href={PING_URL} target="_blank" rel="noreferrer">{PING_URL}</Link> — if you see &#123;&quot;ok&quot;:true,&quot;service&quot;:&quot;super-admin&quot;&#125;, the backend has the settings API; otherwise redeploy the backend.
        </Typography>
      </Alert>
    </Box>
  );
};

export default SettingsErrorAlert;
